import styled from "styled-components";

export const StyledVaultCuratorForm = styled.div``;
